// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/components/layouts'

export const asyncRouterMap = [

    {
        path: '/',
        name: 'index',
        component: BasicLayout,
        meta: { title: '首页' },
        redirect: '/sai/ApplyList',
        // redirect: '/dashboard/analysis',
        children: [

            {
                path: '/dashboard',
                name: 'dashboard',
                redirect: '/sai/ApplyList',
                component: RouteView,
                meta: {
                    title: '首页',
                    keepAlive: true,
                    icon: 'dashboard',
                    permission: ['dashboard']
                },
                children: [
                    {
                        path: '/dashboard/orderanalysis',
                        name: 'OrderAnalysis',
                        component: () =>
                            import ('@/views/dashboard/OrderAnalysis'),
                        meta: { title: '销售分析页', keepAlive: false, permission: ['orderanalysis2'] }
                    },{
                        path: '/settting/gbook',
                        name: 'GBook',
                        component: () =>
                            import ('@/views/site/GBook'),
                        meta: { title: '信箱@CCA', keepAlive: false, permission: ['orderanalysis2'] }
                    },
                    {
                        path: '/site/settings',
                        name: 'SiteSettingIndex',
                        component: () =>
                            import ('@/views/site/SiteSettingIndex'),
                        meta: {
                            title: '设置',
                            hideHeader: true,
                            keepAlive: true,
                            permission: ['setting']
                        },
                        redirect: '/site/settings/user',
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/site/settings/base',
                                name: 'SiteSettingBase',
                                component: () =>
                                    import ('@/views/site/SiteSettingBase'),
                                meta: {
                                    title: '基本设置',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['setting']
                                }
                            },
                            {
                                path: '/site/settings/user',
                                name: 'SiteSettingUser',
                                component: () =>
                                    import ('@/views/site/SiteSettingUser'),
                                meta: {
                                    title: '人员设置', 
                                    keepAlive: true,
                                    permission: ['setting']
                                }
                            },
                            {
                                path: '/site/settings/sellerReward',
                                name: 'SiteSettingSellerReward',
                                component: () =>
                                    import ('@/views/site/SiteSettingSellerReward'),
                                meta: {
                                    title: '分销设置',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['setting']
                                }
                            },
                            {
                                path: '/site/settings/settingReward',
                                name: 'SiteSettingReward',
                                component: () =>
                                    import ('@/views/site/SiteSettingReward'),
                                meta: {
                                    title: '奖励设置',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['setting']
                                }
                            },
                            {
                                path: '/site/settings/partnerCash',
                                name: 'SiteSettingPartnerCash',
                                component: () =>
                                    import ('@/views/site/SiteSettingPartnerCash'),
                                meta: {
                                    title: '合伙人结算设置',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['setting']
                                }
                            },
                            {
                                path: '/site/settings/password',
                                name: 'SiteSettingPassword',
                                component: () =>
                                    import ('@/views/site/SiteSettingPassword'),
                                meta: {
                                    title: '修改密码',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['setting']
                                }
                            }, {
                                path: '/site/settings/wxservice',
                                name: 'SiteSettingWxService',
                                component: () =>
                                    import ('@/views/site/SiteSettingWxService'),
                                meta: {
                                    title: '客服管理',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['setting']
                                }
                            },
                            {
                                path: '/site/settings/bank',
                                name: 'SiteSettingBank',
                                component: () =>
                                    import ('@/views/site/SiteSettingBank'),
                                meta: {
                                    title: '结算账号管理',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['setting']
                                }
                            },
                            {
                                path: '/site/settings/activty',
                                name: 'SiteSettingActivity',
                                component: () =>
                                    import ('@/views/site/SiteSettingActivity'),
                                meta: {
                                    title: '首页倒计时',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['setting']
                                }
                            },
                        ]
                    }
                ]
            },

            // class
            {
                path: '/user',
                name: 'list',
                component: PageView,
                redirect: '/users/weiyuanhuiList',
                meta: { title: '用户', icon: 'table', permission: ['users'] },
                children: [{
                        path: '/users/weiyuanhuiList',
                        name: 'WeiyuanhuiList',
                        component: () =>
                            import ('@/views/users/WeiyuanhuiList'),
                        meta: { title: '省市管理', keepAlive: true, permission: ['weiyuanhuiList2'] },
                    },
                    {
                        path: '/user/userList',
                        name: 'UserList',
                        component: () =>
                            import ('@/views/users/UserList'),
                        meta: {
                            title: '用户管理',
                            keepAlive: true,
                            permission: ['userList']
                        }
                    },
                    {
                        path: '/user/photoList',
                        name: 'PhotoList',
                        component: () =>
                            import ('@/views/users/PhotoList'),
                        meta: {
                            title: '证件照管理',
                            keepAlive: true,
                            permission: ['photoList2']
                        }
                    },

                    {
                        path: '/user/partnerList',
                        name: 'PartnerList',
                        component: () =>
                            import ('@/views/users/PartnerList'),
                        meta: {
                            title: '区域合伙人管理',
                            keepAlive: true,
                            permission: ['partnerList2']
                        }
                    },

                    {
                        path: '/user/caipanList',
                        name: 'CaipanListUser',
                        component: () =>
                            import ('@/views/users/UserLayout'),
                        redirect: '/user/caipanList',
                        meta: { title: '裁判教练运动员', keepAlive: true, hidden: true, permission: ['caipanList2'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/user/caipanList',
                                name: 'CaipanListUser',
                                component: () =>
                                    import ('@/views/users/CaipanList'),
                                meta: { title: '裁判员管理', keepAlive: true, hidden: true, permission: ['caipanList'] },
                            },

                            {
                                path: '/user/jiaolianList',
                                name: 'JiaolianListUser',
                                component: () =>
                                    import ('@/views/users/JiaolianList'),
                                meta: { title: '教练员管理', keepAlive: true, hidden: true, permission: ['caipanList'] },
                            },
                            {
                                path: '/user/yundongyuanList',
                                name: 'YundongyuanList',
                                component: () =>
                                    import ('@/views/users/YundongyuanList'),
                                meta: { title: '运动员管理', keepAlive: true, hidden: true, permission: ['caipanList'] },
                            },

                        ]
                    },

                    {
                        path: '/seller/businessSellerList',
                        name: 'BusinessSellerList',
                        component: () =>
                            import ('@/views/seller/BusinessSellerList'),
                        meta: {
                            title: '分销员',
                            keepAlive: true,
                            permission: ['businessSellerList2']
                        }
                    },
                    {
                        path: '/team/teamList',
                        name: 'TeamList',
                        component: () =>
                            import ('@/views/team/TeamList'),
                        meta: {
                            title: '团队',
                            keepAlive: true,
                            permission: ['teamList2']
                        }
                    },


                ]
            },

            {
                path: '/course',
                name: 'list',
                component: PageView,
                redirect: '/course/courseList',
                meta: { title: '在线课程', icon: 'table', permission: ['course2'] },
                children: [{
                        path: '/course/courseList',
                        name: 'CourseList',
                        component: () =>
                            import ('@/views/course/CourseList'),
                        meta: { title: '课程管理', keepAlive: true, permission: ['CourseList'] },
                    },
                    {
                        path: '/course/courseCateList',
                        name: 'CourseCateList',
                        component: () =>
                            import ('@/views/course/CourseCateList'),
                        meta: { title: '分类管理', keepAlive: true, permission: ['CourseCateList'] },
                    },
                ]
            },
            // {
            //     path: '/kaoji',
            //     name: 'kaojiList',
            //     component: PageView,
            //     redirect: '/kaoji/kaojiList',
            //     meta: { title: '七彩星级考试系统', icon: 'table', permission: ['qcxjexame', 'admin'] },
            //     children: [
            //         {
            //             path: '/kaoji/kaojiList',
            //             name: 'KaojiList',
            //             component: () => import('@/views/kaoji/KaojiList'),
            //             meta: { title: '考试系统', keepAlive: true, permission: ['qcxjexame', 'admin'] },
            //         },
            //     ]
            // },

            {
                path: '/qcxj',
                name: 'list',
                component: PageView,
                redirect: '/qcxj/order-index',
                meta: { title: '七彩星级', icon: 'table', permission: ['qcxj2','KaojiList2'] },
                children: [{
                        path: '/apps/qcxj/ExameCenterList',
                        name: 'ExameCenter',
                        component: () =>
                            import ('@/views/qcxj/ExameCenterLayout'),
                        redirect: '/qcxj/ExameCenterList',
                        meta: { title: '考级中心考级点', keepAlive: true, hidden: true, permission: ['ExameCenter'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/qcxj/ExameCenterList',
                                name: 'ExameCenterList',
                                component: () =>
                                    import ('@/views/qcxj/ExameCenterList'),
                                meta: { title: '考级中心考级点', keepAlive: true, hidden: true, permission: ['ExameCenter'] },
                            },{
                                path: '/qcxj/DataMap',
                                name: 'qcxjDataMap',
                                component: () =>
                                    import ('@/views/qcxj/DataMap'),
                                meta: { title: '统计信息', keepAlive: true, hidden: true, permission: ['ExameCenter'] },
                            },
                            {
                                path: '/qcxj/QcxjTopicList',
                                name: 'QcxjTopicList',
                                component: () =>
                                    import ('@/views/qcxj/TopicList'),
                                meta: { title: '七彩星级话题管理', keepAlive: true, hidden: true, permission: ['ExameCenter'] },
                            },

                        ]
                    },

                    {
                        path: '/qcxj/KaojiApply',
                        name: 'KaojiApply',
                        component: () =>
                            import ('@/views/qcxj/KaojiApplyLayout'),
                        redirect: '/qcxj/KaojiApplyList',
                        meta: { title: '考级申报', keepAlive: true, permission: ['KaojiApply','KaojiList'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/qcxj/KaojiApplyList',
                                name: 'KaojiApplyList',
                                component: () =>
                                    import ('@/views/qcxj/KaojiApplyList'),
                                meta: { title: '考级申报', keepAlive: true, hidden: true, permission: ['KaojiApply','KaojiList'] },
                            },

                            {
                                path: '/qcxj/KaojiMemberList',
                                name: 'KaojiMemberList',
                                component: () =>
                                    import ('@/views/qcxj/KaojiMemberList'),
                                meta: { title: '考级人员管理', keepAlive: true, hidden: true, permission: ['KaojiApply','KaojiList'] },
                            },

                        ]
                    },


                    {
                        path: '/kaoji/kaojiList',
                        name: 'KaojiList',
                        component: () =>
                            import ('@/views/kaoji/KaojiList'),
                        meta: { title: '考试系统', keepAlive: true, permission: ['KaojiList'] },
                    },
                    {
                        path: '/qcxj/settings',
                        name: 'QcxjSettingIndex',
                        component: () =>
                            import ('@/views/qcxj/QcxjSettingIndex'),
                        meta: {
                            title: '七彩星级设置',
                            hideHeader: true,
                            keepAlive: true,
                            permission: ['QcxjSettingIndex']
                        },
                        redirect: '/qcxj/QcxjSettingFile',
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/qcxj/QcxjSettingFile',
                                name: 'QcxjSettingFile',
                                component: () =>
                                    import ('@/views/qcxj/QcxjSettingFile'),
                                meta: {
                                    title: '文件设置',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['QcxjSettingIndex']
                                }
                            },
                            {
                                path: '/qcxj/QcxjSettingKaoji',
                                name: 'QcxjSettingKaoji',
                                component: () =>
                                    import ('@/views/qcxj/QcxjSettingKaoji'),
                                meta: {
                                    title: '考级设置',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['QcxjSettingIndex']
                                }
                            },
                        ]
                    },



                    {
                        path: '/apps/qcxj/QcxjRewards',
                        name: 'QcxjRewards',
                        component: () =>
                            import ('@/views/qcxj/RewardsLayout'),
                        redirect: '/qcxj/cityRewardsList',
                        meta: { title: '奖励结算', keepAlive: true, hidden: true, permission: ['QcxjRewards'] },
                        hideChildrenInMenu: true,
                        children: [
                            // {
                            //     path: '/qcxj/shengshiRewardsList',
                            //     name: 'ShengshiRewardsList',
                            //     component: () =>
                            //         import ('@/views/qcxj/ShengshiRewardsList'),
                            //     meta: { title: '省市奖励', keepAlive: true, hidden: true, permission: ['QcxjRewards'] },
                            // }, 
                            
                            {
                                path: '/qcxj/cityRewardsList',
                                name: 'cityRewardsList',
                                component: () =>
                                    import ('@/views/qcxj/CityRewardsList'),
                                meta: { title: '地市推广奖励', keepAlive: true, hidden: true, permission: ['QcxjRewards'] },
                            }, {
                                path: '/qcxj/partnerRewardsList',
                                name: 'partnerRewardsList',
                                component: () =>
                                    import ('@/views/qcxj/PartnerRewardsList'),
                                meta: { title: '加盟合伙人', keepAlive: true, hidden: true, permission: ['QcxjRewards'] },
                            }, {
                                path: '/qcxj/citysetting',
                                name: 'qcxjcitysetting',
                                component: () =>
                                    import ('@/views/qcxj/CitySetting'),
                                meta: { title: '地市推广设置', keepAlive: true, hidden: true, permission: ['QcxjRewards'] },
                            },

                        ]
                    },
                ]

            },

            {
                path: '/club',
                name: 'list',
                component: PageView,
                redirect: '/club/order-index',
                meta: { title: '星级俱乐部', icon: 'table', permission: ['ClubIndex2'] },
                children: [{
                        path: '/apps/club/ClubIndex',
                        name: 'ClubIndex',
                        component: () =>
                            import ('@/views/club/ClubLayout'),
                        redirect: '/club/ClubList',
                        meta: { title: '星级俱乐部', keepAlive: true, hidden: true, permission: ['ClubIndex'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/club/ClubList',
                                name: 'ClubList',
                                component: () =>
                                    import ('@/views/club/ClubList'),
                                meta: { title: '星级俱乐部', keepAlive: true, hidden: true, permission: ['ClubList', 'admin'] },
                            },
                            {
                                path: '/club/ClubGradeList',
                                name: 'ClubGradeList',
                                component: () =>
                                    import ('@/views/club/ClubGradeList'),
                                meta: { title: '俱乐部赛区升级', keepAlive: true, hidden: true, permission: ['ClubList'] },
                            },
                            {
                                path: '/club/ClubJiansheGradeList',
                                name: 'ClubJiansheGradeList',
                                component: () =>
                                    import ('@/views/club/ClubJiansheGradeList'),
                                meta: { title: '俱乐部建设升级', keepAlive: true, hidden: true, permission: ['ClubList'] },
                            },
                            {
                                path: '/club/ClubScoreApplyList',
                                name: 'ClubScoreApplyList',
                                component: () =>
                                    import ('@/views/club/ClubScoreApplyList'),
                                meta: { title: '俱乐部积分申请', keepAlive: true, hidden: true, permission: ['ClubList'] },
                            },
                            {
                                path: '/club/ClubTopicList',
                                name: 'ClubTopicList',
                                component: () =>
                                    import ('@/views/club/TopicList'),
                                meta: { title: '俱乐部话题管理', keepAlive: true, hidden: true, permission: ['ClubList'] },
                            },
                            {
                                path: '/club/ClubGoodsList',
                                name: 'ClubGoodsList',
                                component: () =>
                                    import ('@/views/club/ClubGoodsList'),
                                meta: { title: '俱乐部建设商品', keepAlive: true, hidden: true, permission: ['ClubList'] },
                            },
                            {
                                path: '/club/ClubJiansheList',
                                name: 'ClubJiansheList',
                                component: () =>
                                    import ('@/views/club/ClubJiansheList'),
                                meta: { title: '俱乐部建设订单', keepAlive: true, hidden: true, permission: ['ClubList'] },
                            },

                        ]
                    },
                    {
                        path: '/apps/cdakejian/DakejianIndex',
                        name: 'CDakejianIndex',
                        component: () =>
                            import ('@/views/cdakejian/DakejianLayout'),
                        redirect: '/cdakejian/DakejianList',
                        meta: { title: '大课间申报', keepAlive: true, hidden: true, permission: ['CDakejianList'] },
                        hideChildrenInMenu: true,
                        children: [{
                            path: '/cdakejian/DakejianList',
                            name: 'CDakejianList',
                            component: () =>
                                import ('@/views/cdakejian/DakejianList'),
                            meta: { title: '大课间申报', keepAlive: true, hidden: true, permission: ['CDakejianList'] },
                        }]
                    },
                    // {
                    //     path: '/apps/crural/RuralIndex',
                    //     name: 'CRuralIndex',
                    //     component: () =>
                    //         import ('@/views/crural/RuralLayout'),
                    //     redirect: '/crural/RuralList',
                    //     meta: { title: '乡村振兴公益活动', keepAlive: true, hidden: true, permission: ['CRuralList'] },
                    //     hideChildrenInMenu: true,
                    //     children: [{
                    //         path: '/crural/RuralList',
                    //         name: 'CRuralList',
                    //         component: () =>
                    //             import ('@/views/crural/RuralList'),
                    //         meta: {
                    //             title: '乡村振兴公益活动',
                    //             keepAlive: true,
                    //             hidden: true,
                    //             permission: ['CRuralList']
                    //         },
                    //     }]
                    // },
                    {
                        path: '/club/clubSaiquList',
                        name: 'CRuralIndex',
                        component: () =>
                            import ('@/views/club/ClubSaiquList'), 
                        meta: { title: '申报赛区配置', keepAlive: true,  permission: ['ClubList'] }, 
                    },
                    {
                        path: '/apps/sihao/SihaoIndex',
                        name: 'CSihaoIndex',
                        component: () =>
                            import ('@/views/sihao/SihaoLayout'),
                        redirect: '/csihao/SihaoList',
                        meta: { title: '四好运动员申报', keepAlive: true, hidden: true, permission: ['SihaoList'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/csihao/SihaoList',
                                name: 'CSihaoList',
                                component: () =>
                                    import ('@/views/sihao/SihaoList'),
                                meta: { title: '四好运动员申报', keepAlive: true, hidden: true, permission: ['SihaoList'] },
                            },
                            {
                                path: '/csihao/SihaomemberList',
                                name: 'SihaoMemberList',
                                component: () =>
                                    import ('@/views/sihao/SihaoMemberList'),
                                meta: { title: '运动员人员管理', keepAlive: true, hidden: true, permission: ['SihaoList'] },
                            },
                        ]
                    }
                ]
            },

            {
                path: '/huiyi',
                name: 'list',
                component: PageView,
                redirect: '/huiyi/huiyi-index',
                meta: { title: '会议培训', icon: 'table', permission: ['huiyi2'] },
                children: [{
                        path: '/huiyi/SaiquList',
                        name: 'HuiyiSaiquList',
                        component: () =>
                            import ('@/views/huiyi/SettingLayout'),
                        redirect: '/huiyi/SaiquList',
                        meta: { title: '培训配置', keepAlive: true, hidden: true, permission: ['HuiyiSaiquList'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/huiyi/SaiquList',
                                name: 'HuiyiSaiquList',
                                component: () =>
                                    import ('@/views/huiyi/SaiquList'),
                                meta: { title: '场次管理', keepAlive: true, hidden: true, permission: ['HuiyiSaiquList'] },
                            },
                            {
                                path: '/huiyi/SaijiList',
                                name: 'HuiyiSaijiList',
                                component: () =>
                                    import ('@/views/huiyi/SaijiList'),
                                meta: { title: '年份管理', keepAlive: true, hidden: true, permission: ['HuiyiSaiquList'] },
                            },
                            {
                                path: '/huiyi/GroupList',
                                name: 'HuiyiGroupList',
                                component: () =>
                                    import ('@/views/huiyi/GroupList'),
                                meta: { title: '分组管理', keepAlive: true, hidden: true, permission: ['HuiyiSaiquList'] },
                            },
                            {
                                path: '/songpei/SongpeiGoodsList',
                                name: 'SongpeiGoodsList',
                                component: () =>
                                    import ('@/views/songpei/SongpeiGoodsList'),
                                meta: { title: '送培物料', keepAlive: true, hidden: true, permission: ['HuiyiSaiquList'] },
                            },
                            {
                                path: '/songpei/SaiquList',
                                name: 'SongpeiSaiquList',
                                component: () =>
                                    import ('@/views/songpei/SaiquList'),
                                meta: { title: '送培场次', keepAlive: true, hidden: true, permission: ['HuiyiSaiquList'] },
                            },
                            {
                                path: '/huiyi/SaiquApplyList',
                                name: 'HuiyiSaiquApplyList',
                                component: () =>
                                    import ('@/views/huiyi/SaiquApplyList'),
                                meta: { title: '申请办培训', keepAlive: true, hidden: true, permission: ['HuiyiSaiquList'] },
                            },
                            {
                                path: '/huiyi/SaiquApplyGoodsList',
                                name: 'HuiyiSaiquApplyGoodsList',
                                component: () =>
                                    import ('@/views/huiyi/SaiquApplyGoodsList'),
                                meta: { title: '送培物料', keepAlive: true, hidden: true, permission: ['HuiyiSaiquList'] },
                            },
                        ]
                    },
                    {
                        path: '/huiyi/ApplyList',
                        name: 'HuiyiApplyList',
                        component: () =>
                            import ('@/views/huiyi/ApplyLayout'),
                        redirect: '/sai/ApplyList',
                        meta: { title: '报名管理', keepAlive: true, hidden: true, permission: ['HuiyiApplyList'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/huiyi/ApplyList',
                                name: 'HuiyiApplyList',
                                component: () =>
                                    import ('@/views/huiyi/ApplyList'),
                                meta: { title: '报名管理', keepAlive: true, hidden: true, permission: ['HuiyiApplyList'] },
                            },
                            {
                                path: '/huiyi/MemberList',
                                name: 'HuiyiMemberList',
                                component: () =>
                                    import ('@/views/huiyi/MemberList'),
                                meta: { title: '人员管理', keepAlive: true, hidden: true, permission: ['HuiyiApplyList'] },
                            },
                            {
                                path: '/songpei/ApplyList',
                                name: 'SongpeiApplyList',
                                component: () =>
                                    import ('@/views/songpei/ApplyList'),
                                meta: { title: '送培报名', keepAlive: true, hidden: true, permission: ['HuiyiApplyList'] },
                            },

                        ]
                    },

                    {
                        path: '/apps/qcxj/KaoguanList',
                        name: 'KaoguanJiandu',
                        component: () =>
                            import ('@/views/qcxj/KaoguanjianduLayout'),
                        redirect: '/qcxj/KaoguanList',
                        meta: { title: '考官监督导师培训师', keepAlive: true, hidden: true, permission: ['KaoguanJiandu'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/qcxj/KaoguanList',
                                name: 'KaoguanList',
                                component: () =>
                                    import ('@/views/qcxj/KaoguanList'),
                                meta: { title: '考官管理', keepAlive: true, hidden: true, permission: ['KaoguanJiandu'] },
                            },
                            {
                                path: '/qcxj/KaoguanMemberList',
                                name: 'KaoguanMemberList',
                                component: () =>
                                    import ('@/views/qcxj/KaoguanMemberList'),
                                meta: { title: '考官人员管理', keepAlive: true, hidden: true, permission: ['KaoguanJiandu'] },
                            },
                            {
                                path: '/qcxj/JianduList',
                                name: 'JianduList',
                                component: () =>
                                    import ('@/views/qcxj/JianduList'),
                                meta: { title: '监督申报管理', keepAlive: true, hidden: true, permission: ['KaoguanJiandu'] },
                            },
                            {
                                path: '/qcxj/JianduMemberList',
                                name: 'JianduMemberList',
                                component: () =>
                                    import ('@/views/qcxj/JianduMemberList'),
                                meta: { title: '监督人员管理', keepAlive: true, hidden: true, permission: ['KaoguanJiandu'] },
                            }, {
                                path: '/qcxj/DaoshiList',
                                name: 'DaoshiList',
                                component: () =>
                                    import ('@/views/qcxj/DaoshiList'),
                                meta: { title: '导师批次管理', keepAlive: true, hidden: true, permission: ['KaoguanJiandu'] },
                            },
                            {
                                path: '/qcxj/DaoshiMemberList',
                                name: 'DaoshiMemberList',
                                component: () =>
                                    import ('@/views/qcxj/DaoshiMemberList'),
                                meta: { title: '导师人员管理', keepAlive: true, hidden: true, permission: ['KaoguanJiandu'] },
                            }, {
                                path: '/qcxj/PeixunshiList',
                                name: 'PeixunshiList',
                                component: () =>
                                    import ('@/views/qcxj/PeixunshiList'),
                                meta: { title: '培训师批次管理', keepAlive: true, hidden: true, permission: ['KaoguanJiandu'] },
                            },
                            {
                                path: '/qcxj/PeixunshiMemberList',
                                name: 'PeixunshiMemberList',
                                component: () =>
                                    import ('@/views/qcxj/PeixunshiMemberList'),
                                meta: { title: '培训师人员管理', keepAlive: true, hidden: true, permission: ['KaoguanJiandu'] },
                            },
                            {
                                path: '/qcxj/KaoguanjianduGrade',
                                name: 'KaoguanjianduGrade',
                                component: () =>
                                    import ('@/views/qcxj/KaoguanjianduGrade'),
                                meta: { title: '批量等级查询', keepAlive: true, hidden: true, permission: ['KaoguanJiandu'] },
                            },

                        ]
                    },

                    /*
                    {
                        path: '/cba/SaiquList',
                        name: 'CbaSaiquList',
                        component: () =>
                            import ('@/views/cba/SettingLayout'),
                        redirect: '/cba/SaiquList',
                        meta: { title: 'CBA培训班', keepAlive: true, hidden: true, permission: ['admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                            path: '/cba/SaiquList',
                            name: 'CbaSaiquList',
                            component: () =>
                                import ('@/views/cba/SaiquList'),
                            meta: { title: '场次管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                        }, ]
                    },
                    {
                        path: '/cba/ApplyList',
                        name: 'CbaApplyList',
                        component: () =>
                            import ('@/views/cba/ApplyLayout'),
                        redirect: '/sai/ApplyList',
                        meta: { title: 'CBA报名管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/cba/ApplyList',
                                name: 'CbaApplyList',
                                component: () =>
                                    import ('@/views/cba/ApplyList'),
                                meta: { title: '报名管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                            },
                            {
                                path: '/cba/ApplyList',
                                name: 'CbaMemberList',
                                component: () =>
                                    import ('@/views/cba/MemberList'),
                                meta: { title: '人员管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                            }

                        ]
                    },*/
                    {
                        path: '/huiyi/CpjlList',
                        name: 'CpjlList',
                        component: () =>
                            import ('@/views/huiyi/CpJlLayout'),
                        redirect: '/huiyi/ShengCaipanManage',
                        meta: { title: '裁判教练管理', keepAlive: true, hidden: true, permission: ['CpjlList', 'admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/huiyi/ShengCaipanManage',
                                name: 'ShengCaipanManage',
                                component: () =>
                                    import ('@/views/huiyi/ShengCaipanManage'),
                                meta: { title: '裁判报名管理', keepAlive: true, hidden: true, permission: ['CpjlList'] },
                            },
                            {
                                path: '/huiyi/ShengCaipanList',
                                name: 'ShengCaipanList',
                                component: () =>
                                    import ('@/views/huiyi/ShengCaipanList'),
                                meta: { title: '裁判人员管理', keepAlive: true, hidden: true, permission: ['CpjlList'] },
                            },
                            {
                                path: '/huiyi/ShengJiaolianManage',
                                name: 'ShengJiaolianManage',
                                component: () =>
                                    import ('@/views/huiyi/ShengJiaolianManage'),
                                meta: { title: '教练报名管理', keepAlive: true, hidden: true, permission: ['CpjlList'] },
                            },
                            {
                                path: '/huiyi/ShengJiaolianList',
                                name: 'ShengJiaolianList',
                                component: () =>
                                    import ('@/views/huiyi/ShengJiaolianList'),
                                meta: { title: '教练人员管理', keepAlive: true, hidden: true, permission: ['CpjlList'] },
                            },
                            {
                                path: '/huiyi/CpJlGrade',
                                name: 'CpJlGrade',
                                component: () =>
                                    import ('@/views/huiyi/CpJlGrade'),
                                meta: { title: '裁判教练等级查询', keepAlive: true, hidden: true, permission: ['CpjlList'] },
                            }

                            ,


                            {
                                path: '/huiyi/GuoCaipanManage',
                                name: 'GuoCaipanManage',
                                component: () =>
                                    import ('@/views/huiyi/GuoCaipanManage'),
                                meta: { title: '国裁判报名管理', keepAlive: true, hidden: true, permission: ['CpjlList'] },
                            },
                            {
                                path: '/huiyi/GuoCaipanList',
                                name: 'GuoCaipanList',
                                component: () =>
                                    import ('@/views/huiyi/GuoCaipanList'),
                                meta: { title: '国裁判人员管理', keepAlive: true, hidden: true, permission: ['CpjlList'] },
                            },
                            {
                                path: '/huiyi/GuoJiaolianManage',
                                name: 'GuoJiaolianManage',
                                component: () =>
                                    import ('@/views/huiyi/GuoJiaolianManage'),
                                meta: { title: '国教练报名管理', keepAlive: true, hidden: true, permission: ['CpjlList'] },
                            },
                            {
                                path: '/huiyi/GuoJiaolianList',
                                name: 'GuoJiaolianList',
                                component: () =>
                                    import ('@/views/huiyi/GuoJiaolianList'),
                                meta: { title: '国教练人员管理', keepAlive: true, hidden: true, permission: ['CpjlList'] },
                            }

                        ]
                    },


                    {
                        path: '/huiyi/SaiquRewardList',
                        name: 'HuiyiRewardList',
                        component: () =>
                            import ('@/views/huiyi/SaiquRewardList'),
                        redirect: '/huiyi/SaiquRewardList',
                        meta: { title: '省市级结算奖励', keepAlive: true, hidden: true, permission: ['HuiyiRewardList'] },
                        hideChildrenInMenu: true,
                        children: [{
                            path: '/huiyi/SaiquRewardList',
                            name: 'HuiyiRewardList',
                            component: () =>
                                import ('@/views/huiyi/SaiquRewardList'),
                            meta: { title: '省市级结算奖励', keepAlive: true, hidden: true, permission: ['HuiyiRewardList'] },
                        }, ],
                    },

                    {
                        path: '/huiyi/DabiaoList',
                        name: 'DabiaoList',
                        component: () =>
                            import ('@/views/huiyi/DabiaoLayout'),
                        redirect: '/huiyi/ShengDabiaoManage',
                        meta: { title: '达标管理', keepAlive: true, hidden: true, permission: ['DabiaoList'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/huiyi/ShengDabiaoManage',
                                name: 'ShengDabiaoManage',
                                component: () =>
                                    import ('@/views/huiyi/ShengDabiaoManage'),
                                meta: { title: '达标报名管理', keepAlive: true, hidden: true, permission: ['DabiaoList'] },
                            },
                            {
                                path: '/huiyi/ShengDabiaoList',
                                name: 'ShengDabiaoList',
                                component: () =>
                                    import ('@/views/huiyi/ShengDabiaoList'),
                                meta: { title: '达标人员管理', keepAlive: true, hidden: true, permission: ['DabiaoList'] },
                            },

                        ]
                    },


                    {
                        path: '/skill/applyList',
                        name: 'SkillLevel',
                        component: () =>
                            import ('@/views/skill/LevelLayout'),
                        redirect: '/skill/applyList',
                        meta: { title: '技术等级', keepAlive: true, hidden: true, permission: ['SkillLevel'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/skill/applyList',
                                name: 'LevelApplyList',
                                component: () =>
                                    import ('@/views/skill/ApplyList'),
                                meta: { title: '申报批次', keepAlive: true, hidden: true, permission: ['SkillLevel'] },
                            },
                            {
                                path: '/skill/ApplyMemberList',
                                name: 'LevelApplyMemberList',
                                component: () =>
                                    import ('@/views/skill/ApplyMemberList'),
                                meta: { title: '申报人员', keepAlive: true, hidden: true, permission: ['SkillLevel'] },
                            },
                            {
                                path: '/skill/ApplySpList',
                                name: 'LevelApplySpList',
                                component: () =>
                                    import ('@/views/skill/ApplySpList'),
                                meta: { title: '审批技术等级', keepAlive: true, hidden: true, permission: ['SkillLevel'] },
                            },
                            {
                                path: '/skill/ApplyMemberSpList',
                                name: 'LevelApplyMemberSpList',
                                component: () =>
                                    import ('@/views/skill/ApplyMemberSpList'),
                                meta: { title: '审批技术人员', keepAlive: true, hidden: true, permission: ['SkillLevel'] },
                            },
                        ]
                    },

                    {
                        path: '/ability/ApplyList',
                        name: 'AbilityApplyList',
                        component: () =>
                            import ('@/views/nlcs/AbilityLayout'),
                        redirect: '/ability/ApplyList',
                        meta: { title: '能力测试', keepAlive: true, hidden: true, permission: ['AbilityApplyList'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/ability/ApplyList',
                                name: 'AbilityApplyList',
                                component: () =>
                                    import ('@/views/nlcs/ApplyList'),
                                meta: { title: '报名管理', keepAlive: true, hidden: true, permission: ['AbilityApplyList'] },
                            },
                            {
                                path: '/ability/ApplyMemberList',
                                name: 'AbilityApplyMemberList',
                                component: () =>
                                    import ('@/views/nlcs/ApplyMemberList'),
                                meta: { title: '人员管理', keepAlive: true, hidden: true, permission: ['AbilityApplyList'] },
                            },
                            {
                                path: '/ability/SaiquList',
                                name: 'AbilitySaiquList',
                                component: () =>
                                    import ('@/views/nlcs/SaiquList'),
                                meta: { title: '场次管理', keepAlive: true, hidden: true, permission: ['AbilityApplyList'] },
                            },
                            {
                                path: '/ability/SaijiList',
                                name: 'AbilitySaijiList',
                                component: () =>
                                    import ('@/views/nlcs/SaijiList'),
                                meta: { title: '年份管理', keepAlive: true, hidden: true, permission: ['AbilityApplyList'] },
                            },
                        ]
                    },
                    {
                        path: '/huiyi/Yeyudengjimemberlist',
                        name: 'Yeyudengjimemberlist',
                        component: () =>
                            import ('@/views/huiyi/Yeyudengjimemberlist'),
                        meta: { title: '业余等级管理', keepAlive: true, hidden: true, permission: ['Yeyudengjimemberlist'] },
                    },

                ]
            },
            {
                path: '/sai',
                name: 'list',
                component: PageView,
                redirect: '/sai/sai-index',
                meta: { title: '赛事报名', icon: 'table', permission: ['sai'] },
                children: [{
                        path: '/sai/SaiquApplyList',
                        name: 'SaiSaiquApplyList',
                        component: () =>
                            import ('@/views/sai/ChouLayout'),
                        redirect: '/sai/SaiquApplyList',
                        meta: { title: '申请筹备', keepAlive: true, hidden: true, permission: ['SaiquApplyList2'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/sai/SaiquApplyList',
                                name: 'SaiSaiquApplyList',
                                component: () =>
                                    import ('@/views/sai/SaiquApplyList'),
                                meta: { title: '赛事申请', keepAlive: true, hidden: true, permission: ['SaiquApplyList'] },
                            },
                            {
                                path: '/sai/SaiquDataList',
                                name: 'SaiquDataList',
                                component: () =>
                                    import ('@/views/sai/SaiquDataList'),
                                meta: { title: '赛事筹备', keepAlive: true, hidden: true, permission: ['SaiquApplyList'] },
                            }, ,
                            {
                                path: '/sai/SaiDateTplDetail',
                                name: 'SaiDateTplDetail',
                                component: () =>
                                    import ('@/views/sai/SaiDateTplDetail'),
                                meta: { title: '赛事筹备模版', keepAlive: true, hidden: true, permission: ['SaiquApplyList'] },
                            },
                        ]
                    },
                    {
                        path: '/sai/SaiquList',
                        name: 'SaiquList',
                        component: () =>
                            import ('@/views/sai/SettingLayout'),
                        redirect: '/sai/SaiquList',
                        meta: { title: '竞赛配置', keepAlive: true, hidden: true, permission: ['SaiquList'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/sai/SaiquList',
                                name: 'SaiquList',
                                component: () =>
                                    import ('@/views/sai/SaiquList'),
                                meta: { title: '赛区管理', keepAlive: true, hidden: true, permission: ['SaiquList'] },
                            },
                            {
                                path: '/sai/SaijiList',
                                name: 'SaijiList',
                                component: () =>
                                    import ('@/views/sai/SaijiList'),
                                meta: { title: '赛季管理', keepAlive: true, hidden: true, permission: ['SaiquList'] },
                            },
                            {
                                path: '/sai/SubjecttypeList',
                                name: 'SubjecttypeList',
                                component: () =>
                                    import ('@/views/sai/SubjecttypeList'),
                                meta: { title: '项目配置', keepAlive: true, hidden: true, permission: ['SaiquList2'] },
                            },
                            {
                                path: '/sai/SubjectmusicList',
                                name: 'SubjectmusicList',
                                component: () =>
                                    import ('@/views/sai/SubjectmusicList'),
                                meta: { title: '项目音乐', keepAlive: true, hidden: true, permission: ['SaiquList2'] },
                            },
                            {
                                path: '/sai/TopicList',
                                name: 'SaiTopicList',
                                component: () =>
                                    import ('@/views/sai/TopicList'),
                                meta: { title: '话题管理', keepAlive: true, hidden: true, permission: ['SaiquList2'] },
                            },
                            {
                                path: '/sai/MemberCaipanList',
                                name: 'MemberCaipanList',
                                component: () =>
                                    import ('@/views/sai/MemberCaipanList'),
                                meta: { title: '裁判库', keepAlive: true, hidden: true, permission: ['SaiquList2'] },
                            },
                            {
                                path: '/sai/SaiquHotelList',
                                name: 'SaiquHotelList',
                                component: () =>
                                    import ('@/views/sai/SaiquHotelList'),
                                meta: { title: '酒店管理', keepAlive: true, hidden: true, permission: ['SaiquList'] },
                            },
                            {
                                path: '/sai/SaiDateDetail',
                                name: 'SaiDateDetail',
                                component: () =>
                                    import ('@/views/sai/SaiDateDetail'),
                                meta: {
                                    title: '赛事日程',
                                    hidden: true,
                                    permission: ['admin']
                                }
                            },
                        ]
                    },
                    {
                        path: '/sai/CaiwuList',
                        name: 'CaiwuList',
                        component: () =>
                            import ('@/views/sai/CaiwuLayout'),
                        redirect: '/sai/CaiwuSaiquList',
                        meta: { title: '赛事财务(测试)', keepAlive: true, hidden: true, permission: ['pay2'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/sai/CaiwuSaiquList',
                                name: 'CaiwuSaiquList',
                                component: () =>
                                    import ('@/views/sai/CaiwuSaiquList'),
                                meta: { title: '赛区汇总', keepAlive: true, hidden: true, permission: ['pay'] },
                            },
                            {
                                path: '/sai/CaiwuDanweiList',
                                name: 'CaiwuDanweiList',
                                component: () =>
                                    import ('@/views/sai/CaiwuDanweiList'),
                                meta: { title: '单位汇总', keepAlive: true, hidden: true, permission: ['pay'] },
                            }, 
                        ]
                    },
                    {
                        path: '/sai/SaiquRewardList',
                        name: 'SaiquRewardList',
                        component: () =>
                            import ('@/views/sai/SaiquRewardList'),
                        redirect: '/sai/SaiquRewardList',
                        meta: { title: '省市级结算奖励', keepAlive: true, hidden: true, permission: ['SaiquRewardList2'] },
                        hideChildrenInMenu: true,
                        children: [{
                            path: '/sai/SaiquRewardList',
                            name: 'SaiquRewardList',
                            component: () =>
                                import ('@/views/sai/SaiquRewardList'),
                            meta: { title: '省市级结算奖励', keepAlive: true, hidden: true, permission: ['SaiquRewardList'] },
                        }, ],
                    },
                    {
                        path: '/sai/VoteGoods',
                        name: 'VoteGoods',
                        component: () =>
                            import ('@/views/sai/VoteGoods'),
                        redirect: '/sai/VoteGoods',
                        meta: { title: '投票商品', keepAlive: true, hidden: true, permission: ['VoteGoods2'] },
                        hideChildrenInMenu: true,
                        children: [{
                            path: '/sai/VoteGoods',
                            name: 'VoteGoods',
                            component: () =>
                                import ('@/views/sai/VoteGoods'),
                            meta: { title: '投票商品', keepAlive: true, hidden: true, permission: ['VoteGoods'] },
                        }, ],
                    },
                    // {
                    //     path: '/sai/DakejianList',
                    //     name: 'DakejianList',
                    //     component: () => import('@/views/dakejian/DakejianLayout'),
                    //     redirect: '/sai/DakejianList',
                    //     meta: {title: '大课间报名', keepAlive: true, hidden: true, permission: ['admin']},
                    //     hideChildrenInMenu: true,
                    //     children: [
                    //         {
                    //             path: '/sai/DakejianList',
                    //             name: 'DakejianList',
                    //             component: () => import('@/views/dakejian/DakejianList'),
                    //             meta: {title: '大课间报名', keepAlive: true, hidden: true, permission: ['admin']},
                    //         }
                    //     ]
                    // },
                    {
                        path: '/sai/DakejianList',
                        name: 'DakejianList',
                        component: () =>
                            import ('@/views/dakejian/DakejianLayout'),
                        redirect: '/sai/DakejianList',
                        meta: { title: '大课间展演申报', keepAlive: true, hidden: true, permission: ['DakejianList2'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/sai/DakejianList',
                                name: 'DakejianList',
                                component: () =>
                                    import ('@/views/dakejian/DakejianList'),
                                meta: { title: '大课间展演申报', keepAlive: true, hidden: true, permission: ['DakejianList'] },
                            },
                            {
                                path: '/sai/DakejianMemberList',
                                name: 'DakejianMemberList',
                                component: () =>
                                    import ('@/views/dakejian/DakejianMemberList'),
                                meta: { title: '申报人员管理', keepAlive: true, hidden: true, permission: ['DakejianList'] },
                            },
                            {
                                path: '/sai/DakejianGoodMemberList',
                                name: 'DakejianGoodMemberList',
                                component: () =>
                                    import ('@/views/dakejian/DakejianGoodMemberList'),
                                meta: { title: '优秀参与人员管理', keepAlive: true, hidden: true, permission: ['DakejianList'] },
                            }
                        ]
                    },
                    {
                        path: '/sai/ApplyList',
                        name: 'ApplyList',
                        component: () =>
                            import ('@/views/sai/ApplyLayout'),
                        redirect: '/sai/ApplyList',
                        meta: { title: '报名管理', keepAlive: true, hidden: true, permission: ['saiDanweiList'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/sai/DanweiList',
                                name: 'DanweiList',
                                component: () =>
                                    import ('@/views/sai/DanweiList'),
                                meta: { title: '单位备案', keepAlive: true, hidden: true, permission: ['saiDanweiList'] },
                            },
                            {
                                path: '/sai/DanweiManageList',
                                name: 'DanweiManageList',
                                component: () =>
                                    import ('@/views/sai/DanweiManageList'),
                                meta: { title: '单位管理', keepAlive: true, hidden: true, permission: ['saiDanweiList'] },
                            },
                            {
                                path: '/sai/ApplyList',
                                name: 'ApplyList',
                                component: () =>
                                    import ('@/views/sai/ApplyList'),
                                meta: { title: '报名管理', keepAlive: true, hidden: true, permission: ['saiDanweiList'] },
                            },
                            {
                                path: '/sai/ApplySubjectList',
                                name: 'ApplySubjectList',
                                component: () =>
                                    import ('@/views/sai/ApplySubjectList'),
                                meta: { title: '项目报名管理', keepAlive: true, hidden: true, permission: ['saiDanweiList'] },
                            },
                            {
                                path: '/sai/ConfrimApplyList',
                                name: 'ConfrimApplyList',
                                component: () =>
                                    import ('@/views/sai/ConfrimApplyList'),
                                meta: { title: '信息确认管理', keepAlive: true, hidden: true, permission: ['saiDanweiList'] },
                            },
                            {
                                path: '/sai/TransApplyList',
                                name: 'TransApplyList',
                                component: () =>
                                    import ('@/views/sai/TransApplyList'),
                                meta: { title: '食宿信息管理', keepAlive: true, hidden: true, permission: ['saiDanweiList'] },
                            },
                            {
                                path: '/sai/ShisuApplyList',
                                name: 'ShisuApplyList',
                                component: () =>
                                    import ('@/views/sai/ShisuApplyList'),
                                meta: { title: '食宿信息管理', keepAlive: true, hidden: true, permission: ['saiDanweiList'] },
                            },
                            // {
                            //     path: '/sai/ApplyListZan',
                            //     name: 'ApplyListZan',
                            //     component: () =>
                            //         import ('@/views/sai/ApplyListZan'),
                            //     meta: { title: '报名管理(集赞)', keepAlive: true, hidden: true, permission: ['saiDanweiList'] },
                            // },
                            // {
                            //     path: '/sai/ApplySubjectListZan',
                            //     name: 'ApplySubjectListZan',
                            //     component: () =>
                            //         import ('@/views/sai/ApplySubjectListZan'),
                            //     meta: { title: '项目报名管理(集赞)', keepAlive: true, hidden: true, permission: ['saiDanweiList'] },
                            // },
                        ],

                    },
                    {
                        path: '/sai/scoreStartList',
                        name: 'ScoreStartListIndex',
                        component: () =>
                            import ('@/views/sai/ScoreLayout'),
                        redirect: '/sai/scoreStartList',
                        meta: { title: '评分系统', keepAlive: true, hidden: true, permission: ['scoreStartList2'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/sai/scoreStartList',
                                name: 'ScoreStartList',
                                component: () =>
                                    import ('@/views/sai/ScoreStartList'),
                                meta: { title: '出场顺序', keepAlive: true, hidden: true, permission: ['scoreStartList'] },
                            },
                            {
                                path: '/sai/scoreRun',
                                name: 'ScoreRun',
                                component: () =>
                                    import ('@/views/sai/ScoreRun'),
                                meta: { title: '正在进行', keepAlive: true, hidden: true, permission: ['scoreStartList'] },
                            },
                            {
                                path: '/sai/scoreList',
                                name: 'ScoreList',
                                component: () =>
                                    import ('@/views/sai/ScoreList'),
                                meta: { title: '成绩查询', keepAlive: true, hidden: true, permission: ['scoreStartList'] },
                            },
                            {
                                path: '/sai/caipanList',
                                name: 'CaipanList',
                                component: () =>
                                    import ('@/views/sai/CaipanList'),
                                meta: { title: '裁判员管理', keepAlive: true, hidden: true, permission: ['scoreStartList'] },
                            },
                            {
                                path: '/sai/jiaolianList',
                                name: 'JiaolianList',
                                component: () =>
                                    import ('@/views/sai/JiaolianList'),
                                meta: { title: '教练员管理', keepAlive: true, hidden: true, permission: ['scoreStartList'] },
                            },
                            {
                                path: '/sai/lingduiList',
                                name: 'LingduiList',
                                component: () =>
                                    import ('@/views/sai/LingduiList'),
                                meta: { title: '领队管理', keepAlive: true, hidden: true, permission: ['scoreStartList'] },
                            },
                            // {
                            //     path: '/sai/scorecaipanList',
                            //     name: 'ScoreCaipanApplyList',
                            //     component: () =>
                            //         import ('@/views/sai/ScoreCaipanApplyList'),
                            //     meta: { title: '执裁记录申请', keepAlive: true, hidden: true, permission: ['scoreStartList'] },
                            // },
                        ]
                    }
                ]
            },
            {
                path: '/dscore',
                name: 'dscore',
                component: PageView,
                redirect: '/dscore/dscoreJianqiuVs',
                meta: { title: '评分系统', icon: 'table', permission: ['sai222'] },
                children: [
                    {
                        path: '/dscore/dscoreJianqiuVs',
                        name: 'dscoreJianqiuVs',
                        component: () =>
                            import ('@/views/dscore/JianqiuVsLayout'),
                        redirect: '/dscore/JianqiuVsGroup',
                        meta: { title: '毽球对战', keepAlive: true, hidden: true, permission: ['scoreStartList'] },
                        hideChildrenInMenu: true,
                        children: [
                            {
                                path: '/dscore/JianqiuVsGroup',
                                name: 'DscoreJianqiuVsGroup',
                                component: () =>
                                    import ('@/views/dscore/JianqiuVsGroup'),
                                meta: { title: '组别管理', keepAlive: true, hidden: true, permission: ['scoreStartList'] },
                            }, 
                            {
                                path: '/dscore/JianqiuStartList',
                                name: 'DscoreJianqiuStartList',
                                component: () =>
                                    import ('@/views/dscore/JianqiuStartList'),
                                meta: { title: '场次管理', keepAlive: true, hidden: true, permission: ['scoreStartList'] },
                            }, 
                            {
                                path: '/dscore/JianqiuVsMap',
                                name: 'DscoreJianqiuVsMap',
                                component: () =>
                                    import ('@/views/dscore/JianqiuVsMap'),
                                meta: { title: '对阵管理', keepAlive: true, hidden: true, permission: ['scoreStartList'] },
                            }, 
                            {
                                path: '/dscore/JianqiuPlaceList',
                                name: 'DscoreJianqiuPlaceList',
                                component: () =>
                                    import ('@/views/dscore/JianqiuPlaceList'),
                                meta: { title: '场地管理', keepAlive: true, hidden: true, permission: ['scoreStartList'] },
                            }, 
                        ]
                    }
                ]
            },
            {
                path: '/cms',
                name: 'cms',
                component: PageView,
                redirect: '/cms/cms-index',
                meta: { title: '文章管理', icon: 'table', permission: ['cms'] },
                children: [{
                    path: '/apps/cms/ContentList',
                    name: 'CmsContentList',
                    component: () =>
                        import ('@/views/cms/CmsLayout'),
                    redirect: '/cms/ExameCenterList',
                    meta: { title: '文章管理', keepAlive: true, hidden: true, permission: ['CmsContentList'] },
                    hideChildrenInMenu: true,
                    children: [{
                            path: '/cms/ContentList',
                            name: 'CmsContentList',
                            component: () =>
                                import ('@/views/cms/ContentList'),
                            meta: { title: '文章管理', keepAlive: true, hidden: true, permission: ['CmsContentList'] },
                        },
                        {
                            path: '/cms/CateList',
                            name: 'CmsCateList',
                            component: () =>
                                import ('@/views/cms/CateList'),
                            meta: { title: '文章管理', keepAlive: true, hidden: true, permission: ['CmsContentList'] },
                        },

                    ]
                }]
            },
            {
                path: '/wexame',
                name: 'cms',
                component: PageView,
                redirect: '/wexame/wexame-index',
                meta: { title: '试卷管理', icon: 'table', permission: ['wexame2'] },
                children: [{
                    path: '/apps/wexame/WexameList',
                    name: 'WexameList',
                    component: () =>
                        import ('@/views/wexame/WexameLayout'),
                    redirect: '/wexame/WexameList',
                    meta: { title: '试卷管理', keepAlive: true, hidden: true, permission: ['WexameList'] },
                    hideChildrenInMenu: true,
                    children: [{
                            path: '/wexame/WexameList',
                            name: 'WexameList',
                            component: () =>
                                import ('@/views/wexame/WexameList'),
                            meta: { title: '试卷管理', keepAlive: true, hidden: true, permission: ['WexameList'] },
                        },

                    ]
                }]
            },
            // class
            {
                path: '/goods/goods-list',
                name: 'goods',
                component: PageView,
                redirect: '/class/class-list',
                meta: {
                    title: '商品管理',
                    icon: 'shopping',
                    permission: ['goods']
                },
                children: [{
                        path: '/goods/goods-index',
                        name: 'GoodsIndex',
                        redirect: '/goods/goods-list',
                        component: () =>
                            import ('@/views/goods/GoodsIndex'),
                        meta: {
                            title: '线上商品',
                            keepAlive: true,
                            permission: ['GoodsList']
                        },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/goods/goods-list',
                                name: 'GoodsList',
                                component: () =>
                                    import ('@/views/goods/GoodsList'),
                                meta: {
                                    title: '线上商品',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['GoodsList']
                                }
                            },
                            {
                                path: '/goods/goods-form',
                                name: 'GoodsForm',
                                component: () =>
                                    import ('@/views/goods/form/GoodsForm'),
                                meta: {
                                    title: '商品操作',
                                    hidden: true,
                                    permission: ['GoodsList']
                                }
                            },
                        ]
                    },
                    {
                        path: '/goods/goodssku',
                        name: 'GoodsSkuList',
                        hidden: true,
                        component: () =>
                            import ('@/views/goods/GoodsSkuList'),
                        meta: {
                            title: '库存管理',
                            keepAlive: true,
                            permission: ['GoodsSkuList']
                        }
                    },
                    {
                        path: '/goods/business-base',
                        name: 'BusinessBaseList',
                        hidden: true,
                        component: () =>
                            import ('@/views/goods/BusinessBaseList'),
                        meta: {
                            title: '供应商管理',
                            keepAlive: true,
                            permission: ['BusinessBaseList']
                        }
                    },
                    {
                        path: '/goods/sale-company',
                        name: 'SaleCompany',
                        hidden: true,
                        component: () =>
                            import ('@/views/goods/SaleCompanyList'),
                        meta: {
                            title: '客户单位管理',
                            keepAlive: true,
                            permission: ['BusinessBaseList']
                        }
                    },
                    {
                        path: '/goods/business-supply',
                        name: 'BusinessSupplyList',
                        hidden: true,
                        component: () =>
                            import ('@/views/goods/BusinessSupplyList'),
                        meta: {
                            title: '归属商管理',
                            keepAlive: true,
                            permission: ['BusinessSupplyList']
                        }
                    },
                    {
                        path: '/list/express-tpl-list',
                        name: 'ExpressTplList',
                        component: () =>
                            import ('@/views/goods/ExpressTplList'),
                        meta: {
                            title: '运费模板',
                            keepAlive: true,
                            permission: ['ExpressTplList']
                        }
                    },
                    {
                        path: '/setting/indexPage',
                        name: 'IndexPage',
                        hidden: true,
                        component: () =>
                            import ('@/views/page/IndexPage'),
                        meta: { title: '页面管理', keepAlive: true, permission: ['IndexPage'] }
                    },
                    {
                        path: '/goods/goods-cate-list',
                        name: 'GoodsCateList',
                        component: () =>
                            import ('@/views/goods/GoodsCateList'),
                        meta: {
                            title: '商品分类',
                            keepAlive: true,
                            permission: ['GoodsCateList']
                        }
                    },
                    {
                        path: '/seller/businessSellerGroupList',
                        name: 'BusinessSellerGroupList',
                        hidden: true,
                        component: () =>
                            import ('@/views/seller/BusinessSellerGroupList'),
                        meta: {
                            title: '商家分销员等级',
                            keepAlive: true,
                            permission: ['BusinessSellerGroupList']
                        }
                    },
                    {
                        path: '/order/order-index',
                        name: 'OrderIndex',
                        hidden: true,
                        redirect: '/order/order-list',
                        component: () =>
                            import ('@/views/order/OrderIndex'),
                        meta: {
                            title: 'C端订单管理',
                            keepAlive: true,
                            hidden: true,
                            permission: ['order']
                        },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/order/order-list',
                                name: 'OrderList',
                                component: () =>
                                    import ('@/views/order/OrderList'),
                                meta: {
                                    title: 'C端订单管理',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['order']
                                }
                            },

                            {
                                path: '/order/order-detail',
                                name: 'OrderDetail',
                                component: () =>
                                    import ('@/views/order/OrderDetail'),
                                meta: {
                                    title: '订单详情',
                                    hidden: true,
                                    permission: ['order']
                                }
                            },
                        ]
                    },
                    {
                        path: '/user/partnerGroupList',
                        name: 'PartnerGroupList',
                        hidden: true,
                        component: () =>
                            import ('@/views/users/PartnerGroupList'),
                        meta: {
                            title: '合伙人价格体系',
                            keepAlive: true,
                            permission: ['PartnerGroupList']
                        }
                    },
                    {
                        path: '/check/purchase',
                        name: 'Purchase',
                        hidden: true,
                        component: () =>
                            import ('@/views/jxc/Purchase'),
                        meta: { title: '进货管理', keepAlive: true, permission: ['Purchase'] }
                    }, {
                        path: '/check/inventory',
                        name: 'Inventory',
                        hidden: true,
                        component: () =>
                            import ('@/views/jxc/Inventory'),
                        meta: { title: '盘点管理', keepAlive: true, permission: ['Inventory'] }
                    },
                    {
                        path: '/check/ConfigureList',
                        name: 'ConfigureList',
                        hidden: true,
                        component: () =>
                            import ('@/views/jxc/ConfigureList'),
                        meta: { title: '销售配置', keepAlive: true, permission: ['ConfigureList'] }
                    },
                    {
                        path: '/check/orderList',
                        name: 'JxcOrderList',
                        hidden: true,
                        component: () =>
                            import ('@/views/jxc/JxcOrderList'),
                        meta: { title: 'B端订单管理', keepAlive: true, permission: ['JxcOrderList'] },

                    },
                    {
                        path: '/check/stockChangeList',
                        name: 'StockChangeList',
                        hidden: true,
                        component: () =>
                            import ('@/views/jxc/StockChangeList'),
                        meta: { title: '库存变动', keepAlive: true, permission: ['StockChangeList'] }
                    },
                ]
            },

            {
                path: '/apps',
                name: 'apps',
                component: PageView,
                meta: {
                    title: '营销中心',
                    icon: 'appstore',
                    permission: ['sai2']
                },
                children: [
                    {
                        path: '/apps/app-list',
                        name: 'AppList',
                        component: () => import('@/views/apps/AppList'),
                        meta: {
                            title: '营销中心',
                            keepAlive: true,
                            permission: ['sai']
                        },
                    },
                    {
                        path: '/apps/preferential/preferentialList',
                        name: 'PreferentialList',
                        component: () =>
                            import ('@/views/apps/preferential/PreferentialList'),
                        meta: {
                            title: '限时优惠',
                            keepAlive: true,
                            permission: ['PreferentialList']
                        },
                    },
                    {
                        path: '/apps/tuan/tuanList',
                        name: 'TuanList',
                        component: () =>
                            import ('@/views/apps/tuan/TuanList'),
                        meta: {
                            title: '多人拼团',
                            keepAlive: true,
                            permission: ['tuanList']
                        },
                    },
                    //   {
                    //     path: '/apps/coupon/couponList',
                    //     name: 'CouponList',
                    //     component: () => import('@/views/apps/coupon/CouponList'),
                    //     meta: {
                    //       title: '优惠券',
                    //       keepAlive: true,
                    //       permission: ['admin']
                    //     },
                    //   },
                    // {
                    //     path: '/apps/kanjia/kanjiaList',
                    //     name: 'KanjiaList',
                    //     component: () => import('@/views/apps/kanjia/KanjiaList'),
                    //     meta: {
                    //         title: '助力砍价',
                    //         keepAlive: true,
                    //         permission: ['apps']
                    //     },
                    // },
                    // {
                    //     path: '/apps/jielong/jialongList',
                    //     name: 'JielongList',
                    //     component: () => import('@/views/apps/jielong/JielongList'),
                    //     meta: {
                    //         title: '接龙',
                    //         keepAlive: true,
                    //         permission: ['apps']
                    //     },
                    // },
                    //   {
                    //     path: '/apps/guafen/guafenList',
                    //     name: 'GuafenList',
                    //     component: () => import('@/views/apps/guafen/GuafenList'),
                    //     meta: {
                    //       title: '瓜分券',
                    //       keepAlive: true,
                    //       permission: ['admin']
                    //     },
                    //   },
                    //   {
                    //     path: '/apps/luck/luckList',
                    //     name: 'LuckList',
                    //     component: () => import('@/views/apps/luck/LuckList'),
                    //     meta: {
                    //       title: '幸运抽奖',
                    //       keepAlive: true,
                    //       permission: ['admin']
                    //     },
                    //   },
                ]
            },

            // {
            //     path: '/check',
            //     name: 'apps',
            //     component: PageView,
            //     meta: {
            //         title: '进销存管理',
            //         icon: 'table',
            //         permission: ['admin']
            //     },
            //     children: [{
            //             path: '/check/purchase',
            //             name: 'Purchase',
            //             component: () =>
            //                 import ('@/views/jxc/Purchase'),
            //             meta: { title: '进货管理', keepAlive: true, permission: ['admin'] }
            //         }, {
            //             path: '/check/inventory',
            //             name: 'Inventory',
            //             component: () =>
            //                 import ('@/views/jxc/Inventory'),
            //             meta: { title: '盘点管理', keepAlive: true, permission: ['admin'] }
            //         },
            //         {
            //             path: '/check/ConfigureList',
            //             name: 'ConfigureList',
            //             component: () =>
            //                 import ('@/views/jxc/ConfigureList'),
            //             meta: { title: '销售配置', keepAlive: true, permission: ['admin'] }
            //         },
            //         {
            //             path: '/check/orderList',
            //             name: 'JxcOrderList',
            //             component: () =>
            //                 import ('@/views/jxc/JxcOrderList'),
            //             meta: { title: '销售订单', keepAlive: true, permission: ['admin'] },

            //         },
            //         {
            //             path: '/check/stockChangeList',
            //             name: 'StockChangeList',
            //             component: () =>
            //                 import ('@/views/jxc/StockChangeList'),
            //             meta: { title: '库存变动', keepAlive: true, permission: ['admin'] }
            //         },
            //         // {
            //         //     path: '/check/orderUserList',
            //         //     name: 'OrderUserList',
            //         //     component: () =>
            //         //         import ('@/views/jxc/OrderUserList'),
            //         //     meta: { title: '员工销售统计', keepAlive: true, permission: ['admin'] }
            //         // },
            //     ]
            // },

            {
                path: '/order',
                name: 'pay',
                component: PageView,
                meta: {
                    title: '支付管理',
                    icon: 'table',
                    permission: ['pay2']
                },
                children: [{
                        path: '/order/OrderPayLog',
                        name: 'OrderPayLog',
                        component: () =>
                            import ('@/views/order/OrderPayLog'),
                        meta: { title: '支付记录', keepAlive: true, permission: ['OrderPayLog'] }
                    }, {
                        path: '/order/OrderRefundLog',
                        name: 'OrderRefundLog',
                        component: () =>
                            import ('@/views/order/OrderRefundLog'),
                        meta: { title: '退款记录', keepAlive: true, permission: ['OrderRefundLog'] }
                    },
                    {
                        path: '/cashaccount/cashaccount-list',
                        name: 'Cashaccount',
                        redirect: '/cashaccount/cashaccount-list',
                        component: () =>
                            import ('@/views/cashaccount/CashaccountLayout'),
                        meta: { title: '现金账户', keepAlive: true, hidden: true, permission: ['cashaccount2'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/cashaccount/cashaccount-list',
                                name: 'CashaccountList',
                                component: () =>
                                    import ('@/views/cashaccount/CashaccountList'),
                                meta: { title: '现金账户', keepAlive: true, hidden: true, permission: ['cashaccount'] },
                            },
                            {
                                path: '/cashaccount/withdraw-list',
                                name: 'WithdrawList',
                                component: () =>
                                    import ('@/views/cashaccount/WithdrawList'),
                                meta: { title: '提现申请', keepAlive: true, hidden: true, permission: ['cashaccount'] },
                            }
                        ]
                    }, {
                        path: '/order/withdrawalList',
                        name: 'WithdrawalList',
                        component: () =>
                            import ('@/views/order/WithdrawalList'),
                        meta: { title: '提现管理', keepAlive: true, permission: ['WithdrawalList2'] }
                    },
                ]
            },
            {
                path: '/warehouse',
                name: 'apps',
                component: PageView,
                meta: {
                    title: '仓库管理',
                    icon: 'table',
                    permission: ['warehouse2']
                },
                children: [{
                        path: '/warehouse/order-index',
                        name: 'OrderIndex',
                        redirect: '/warehouse/order-list',
                        component: () =>
                            import ('@/views/warehouse/OrderIndex'),
                        meta: {
                            title: '待发货列表',
                            keepAlive: true,
                            hidden: true,
                            permission: ['warehouseOrderIndex']
                        },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/warehouse/order-list',
                                name: 'OrderList',
                                component: () =>
                                    import ('@/views/order/OrderList'),
                                meta: {
                                    title: '待发货列表',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['warehouseOrderIndex']
                                }
                            },

                            {
                                path: '/warehouse/order-detail',
                                name: 'OrderDetail',
                                component: () =>
                                    import ('@/views/warehouse/OrderDetail'),
                                meta: {
                                    title: '订单详情',
                                    hidden: true,
                                    permission: ['warehouseOrderIndex']
                                }
                            },
                        ]
                    },
                    {
                        path: '/warehouse/return-order-list',
                        name: 'ReturnOrderList',
                        component: () =>
                            import ('@/views/warehouse/ReturnOrderList'),
                        meta: {
                            title: '退换货列表',
                            hidden: true,
                            keepAlive: true,
                            permission: ['ReturnOrderList']
                        }
                    },
                    {
                        path: '/warehouse/inout',
                        name: 'InventoryInout',
                        component: () =>
                            import ('@/views/warehouse/InventoryInout'),
                        meta: { title: '出库', keepAlive: true, permission: ['InventoryInout'] }
                    },
                    {
                        path: '/warehouse/into',
                        name: 'InventoryInto',
                        component: () =>
                            import ('@/views/warehouse/InventoryInto'),
                        meta: { title: '入库', keepAlive: true, permission: ['InventoryInto'] }
                    },
                    {
                        path: '/check/inventory',
                        name: 'Inventory',
                        component: () =>
                            import ('@/views/jxc/Inventory'),
                        meta: { title: '盘点管理', keepAlive: true, permission: ['jxcInventory'] }
                    },
                    {
                        path: '/check/purchase',
                        name: 'Purchase',
                        component: () =>
                            import ('@/views/jxc/Purchase'),
                        meta: { title: '进货管理', keepAlive: true, permission: ['jxcPurchase'] }
                    },
                    {
                        path: '/check/stockChangeList',
                        name: 'StockChangeList',
                        component: () =>
                            import ('@/views/jxc/StockChangeList'),
                        meta: { title: '库存变动', keepAlive: true, permission: ['jxcStockChangeList'] }
                    },
                    {
                        path: '/check/goodssku',
                        name: 'GoodsSkuList',
                        component: () =>
                            import ('@/views/goods/GoodsSkuList'),
                        meta: { title: '库存管理', keepAlive: true, permission: ['jxcGoodsSkuList'] }
                    },

                    // {
                    //     path: '/warehouse/return-order-list',
                    //     name: 'ReturnOrderList',
                    //     component: () =>
                    //         import ('@/views/warehouse/ReturnOrderList'),
                    //     meta: {
                    //         title: '退换货列表',
                    //         hidden: true,
                    //         keepAlive: true,
                    //         permission: ['warehouse']
                    //     },
                    //     hideChildrenInMenu: true,
                    //     children: [{
                    //             path: '/warehouse/return-order-list',
                    //             name: 'ReturnOrderList',
                    //             component: () =>
                    //                 import ('@/views/warehouse/ReturnOrderList'),
                    //             meta: {
                    //                 title: '退换货列表',
                    //                 hidden: true,
                    //                 keepAlive: true,
                    //                 permission: ['warehouse']
                    //             }
                    //         },

                    //         {
                    //             path: '/warehouse/order-detail',
                    //             name: 'OrderDetail',
                    //             component: () =>
                    //                 import ('@/views/warehouse/OrderDetail'),
                    //             meta: {
                    //                 title: '订单详情',
                    //                 hidden: true,
                    //                 permission: ['warehouse']
                    //             }
                    //         },
                    //     ]
                    // },


                ]
            },
            // forms

            // list

            // profile
            // result

            // Exception

            // account
        ]
    },
    {
        path: '*',
        redirect: '/404',
        hidden: true
    }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [{
        path: '/user',
        component: UserLayout,
        redirect: '/user/login',
        hidden: true,
        children: [{
                path: 'login',
                name: 'login',
                component: () =>
                    import ( /* webpackChunkName: "user" */ '@/views/user/Login')
            },
            {
                path: 'register',
                name: 'register',
                component: () =>
                    import ( /* webpackChunkName: "user" */ '@/views/user/Register')
            },
            {
                path: 'register-result',
                name: 'registerResult',
                component: () =>
                    import ( /* webpackChunkName: "user" */ '@/views/user/RegisterResult')
            }
        ]
    },

    {
        path: '/test',
        component: BlankLayout,
        redirect: '/test/home',
        children: [{
            path: 'home',
            name: 'TestHome',
            component: () =>
                import ('@/views/Home')
        }]
    },

    {
        path: '/404',
        component: () =>
            import ( /* webpackChunkName: "fail" */ '@/views/exception/404')
    },

    {
        path: '/sai/scoreForm',
        name: 'ScoreForm',
        component: () =>
            import ('@/views/sai/ScoreForm'),
        meta: { title: '评分页', keepAlive: true, hidden: true, permission: ['caipan', 'admin'] },
    },
    {
        path: '/kaoji/scoreForm',
        name: 'KaojiScoreForm',
        component: () =>
            import ('@/views/kaoji/ScoreForm'),
        meta: { title: '七彩星级考试系统', keepAlive: true, hidden: true, permission: ['caipan', 'admin'] },
    },
    {
        path: '/sai/scoreShow',
        name: 'ScoreShow',
        component: () =>
            import ('@/views/sai/ScoreShow'),
        meta: { title: '数据展示', keepAlive: true, hidden: true, permission: ['caipan', 'admin'] },
    },


    {
        path: '/sai/scoreStartMachineList',
        name: 'ScoreStartMachineList',
        component: () =>
            import ('@/views/sai/ScoreStartMachineList'),
        meta: { title: '字幕机展示', keepAlive: true, hidden: true, permission: ['caipan', 'admin'] },
    },
    {
        path: '/sai/scoreStartMachineArmy',
        name: 'ScoreStartMachineArmy',
        component: () =>
            import ('@/views/sai/ScoreStartMachineArmy'),
        meta: { title: '队伍信息', keepAlive: true, hidden: true, permission: ['caipan', 'admin'] },
    },

    {
        path: '/sai/scoreStartMachineRank',
        name: 'ScoreStartMachineRank',
        component: () =>
            import ('@/views/sai/ScoreStartMachineRank'),
        meta: { title: '队伍成绩', keepAlive: true, hidden: true, permission: ['caipan', 'admin'] },
    },

    {
        path: '/sai/scoreStartMachineSubjectRank',
        name: 'ScoreStartMachineSubjectRank',
        component: () =>
            import ('@/views/sai/ScoreStartMachineSubjectRank'),
        meta: { title: '项目排名', keepAlive: true, hidden: true, permission: ['caipan', 'admin'] },
    },

]